"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PAGE_RECURRING_SETTINGS = exports.projectResponseSchema = exports.projectRequestSchema = exports.paymentSettingsEnabledSchema = exports.paymentSettingsSchema = void 0;
var zod_1 = require("zod");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var recurringAnchorDatePreset = zod_1.z.object({
    kind: zod_1.z.literal("anchor_preset"),
    value: zod_1.z.enum(["acceptance"]),
});
var recurringDateValue = zod_1.z.object({
    kind: zod_1.z.literal("value"),
    value: zod_1.z.string().datetime(),
});
var recurringEndDatePreset = zod_1.z.object({
    kind: zod_1.z.literal("cycles"),
    value: zod_1.z.number().min(1).nullable(),
});
var recurringStartDatePreset = zod_1.z.object({
    kind: zod_1.z.literal("start_preset"),
    value: zod_1.z.enum(["acceptance"]),
});
var recurringSettings = zod_1.z.object({
    anchorDate: recurringAnchorDatePreset.or(recurringDateValue),
    endDate: recurringEndDatePreset.or(recurringDateValue),
    startDate: recurringStartDatePreset.or(recurringDateValue),
    freeTrialDays: zod_1.z.number().min(0),
    excludedLineItems: zod_1.z.array(zod_1.z.string()).optional(),
    prorateChanges: zod_1.z.boolean(),
});
var recurringConfigSettings = zod_1.z.record(zod_1.z.nativeEnum(Types_1.RecurringFrequency), recurringSettings);
var recurringInvoiceConfig = zod_1.z.object({
    daysUntilDue: zod_1.z.number(),
    enabled: zod_1.z.boolean(),
    paymentMethods: zod_1.z.array(zod_1.z.string()),
});
var settingsMap = zod_1.z.record(zod_1.z.nativeEnum(Types_1.RecurringFrequency), recurringSettings);
exports.paymentSettingsSchema = zod_1.z.object({
    customBusinessName: zod_1.z.string().optional(),
    discoverable: zod_1.z.boolean().optional().default(false),
    enabled: zod_1.z.boolean(),
    extraInformation: zod_1.z.string().optional(),
    gatewayId: zod_1.z.string().nullable(),
    partialPaymentConfig: zod_1.z
        .object({
        enabled: zod_1.z.boolean(),
        amount: zod_1.z.number(),
        kind: zod_1.z.enum(["fixed", "percentage"]),
    })
        .optional()
        .default({
        enabled: false,
        amount: 0,
        kind: "fixed",
    }),
    recurringConfig: zod_1.z
        .object({
        enabled: zod_1.z.boolean(),
        defaultSettings: recurringSettings.optional(),
        invoiceConfig: recurringInvoiceConfig.optional(),
        settings: settingsMap.optional(),
    })
        .or(zod_1.z.any().transform(function () { return undefined; }))
        .nullish(),
    requireOnAccept: zod_1.z.boolean().optional().default(false),
    payLaterButtonText: zod_1.z.string().optional(),
});
exports.paymentSettingsEnabledSchema = exports.paymentSettingsSchema.extend({
    enabled: zod_1.z.literal(true),
    gatewayId: zod_1.z.string(),
});
exports.projectRequestSchema = zod_1.z
    .object({
    paymentSettings: exports.paymentSettingsSchema
        .extend({
        gatewayId: zod_1.z.string(),
    })
        .partial(),
})
    .partial()
    .passthrough();
exports.projectResponseSchema = zod_1.z.object({
    currency: zod_1.z.string(),
    paymentSettings: exports.paymentSettingsSchema,
});
exports.DEFAULT_PAGE_RECURRING_SETTINGS = {
    anchorDate: { kind: "anchor_preset", value: "acceptance" },
    endDate: { kind: "cycles", value: null },
    freeTrialDays: 0,
    prorateChanges: true,
    startDate: { kind: "start_preset", value: "acceptance" },
};
